import { Inject, Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { DOCUMENT } from '@angular/common';
import { sha256 } from 'js-sha256';

@Injectable({ providedIn: 'root' })
export class JwtJsSha256CryptoService {
  constructor(@Inject(DOCUMENT) private readonly doc: Document) {}

  generateCodeChallenge(codeVerifier: string): Observable<string> {
    return this.calcHash(codeVerifier).pipe(
      map((challengeRaw: string) => {
        return this.base64UrlEncode(challengeRaw);
      })
    );
  }

  private calcHash(valueToHash: string): Observable<string> {
    let byteArray = sha256.digest(valueToHash);
    const hashString = this.toHashString(byteArray);
    return of(hashString);
  }

  private toHashString(byteArray: number[]): string {
    let result = '';

    for (const e of byteArray) {
      result += String.fromCharCode(e);
    }

    return result;
  }

  private base64UrlEncode(str: string): string {
    const base64: string = btoa(str);

    return base64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
  }
}
